// Renders the Formik inputs for a set of field specs. Used by the create
// wizard (step 4) and by AddRailsModal. Field names are `fields.<key>`.
import { FormikInput } from '@/components/form/fields/FormikInput/FormikInput';
import { ResponseErrorType } from '@/types/sharedTypes';
import { FieldMetaType, VaultHolderType } from '@/types/myVaultTypes';
import { OptionGrid } from '../../styles';
import { ACCOUNT_TYPES_OPTIONS, WIDE_FIELD_KEYS } from '../../const/const';
import { FormikRadioGroup } from '@/components/form/fields/FormikRadioGroup/FormikRadioGroup';
import { BankNameField } from './BankNameField';

type RailFieldsType = {
  fields: Omit<FieldMetaType, 'rails'>[];
  holderType?: VaultHolderType;
  bankName?: string;
  apiError?: ResponseErrorType;
};

const beneficiaryLabel = (holderType?: VaultHolderType) =>
  holderType === 'individual' ? 'Beneficiary name (full legal name)' : 'Beneficiary name (business legal name)';

export const RailFields = ({ fields, holderType, bankName, apiError }: RailFieldsType) => {
  return (
    <OptionGrid $cols={2}>
      {fields.map((field) => {
        const label = field.key === 'beneficiary_name' ? beneficiaryLabel(holderType) : field.label;
        const placeholder = field.key === 'bank_name' && bankName ? bankName : field.placeholder;
        const wide = WIDE_FIELD_KEYS.includes(field.key);
        const formattedLabel = `${label}${field.optional ? ' (optional)' : '*'}`;

        if (field.key === 'account_type') {
          return (
            <div key={field.key} style={wide ? { gridColumn: 'span 2' } : undefined}>
              <FormikRadioGroup
                name={`fields.${field.key}`}
                label={formattedLabel}
                options={ACCOUNT_TYPES_OPTIONS}
                apiError={apiError}
                hasErrorComponent
                gridMode
              />
            </div>
          );
        }

        if (field.key === 'bank_name') {
          return (
            <BankNameField
              key={field.key}
              field={field}
              wide={wide}
              apiError={apiError}
              placeholder={placeholder}
              label={formattedLabel}
            />
          );
        }

        return (
          <div key={field.key} style={wide ? { gridColumn: 'span 2' } : undefined}>
            <FormikInput
              name={`fields.${field.key}`}
              label={formattedLabel}
              placeholder={placeholder}
              autoComplete='new-field'
              apiError={apiError}
            />
          </div>
        );
      })}
    </OptionGrid>
  );
};
